const urls = {
  websocket: {
    ws: 'ws://www.iotena-web.com/wss',
  },
  login: {
    get_code_image: 'https://www.inhealth.iotena.com/api/common/get_code_image',/*获取验证码图片*/
    login: 'https://www.inhealth.iotena.com/api/common/login',/*登陆*/
    getCode: 'https://www.inhealth.iotena.com/api/common/get_code',/*忘记密码获取邮箱验证码*/
    chargePassword: 'https://www.inhealth.iotena.com/api/common/charge_password',/*忘记密码设置新密码*/
  },
  dashboard: {
    countryList: 'https://www.inhealth.iotena.com/api/area/country_list',/*导航栏国家下拉*/
    provinceList: 'https://www.inhealth.iotena.com/api/area/province_list',/*导航栏省份下拉*/
    cityList: 'https://www.inhealth.iotena.com/api/area/city_list',/*导航栏城市下拉*/
    homeData: 'https://www.inhealth.iotena.com/api/home/data',/*首页概览数据*/
    hotelList: 'https://www.inhealth.iotena.com/api/area/hotel_list',/*酒店下拉列表*/
    hotelView: 'https://www.inhealth.iotena.com/api/home/hotel_view',/*酒店概览列表*/
    alarmInfo: 'https://www.inhealth.iotena.com/api/home/alarm_info',/*故障信息*/
    getHotelWeather: 'https://www.inhealth.iotena.com/api/home/get_hotel_weather',/*酒店天气信息*/
    // roomEnvStatus:'https://www.inhealth.iotena.com/api/home/room_env_status',/*首页空气质量跟传感器平均数据*/
    energyConsumption: 'https://www.inhealth.iotena.com/api/home/energy_consumption',/*首页用电量统计信息表*/
    lightingUseSchedule: 'https://www.inhealth.iotena.com/api/home/lighting_use_schedule',/*首页设备工作时间统计信息*/
    roomTemAvg: 'https://www.inhealth.iotena.com/api/home/room_tem_avg',/*房间平均温度统计信息*/
    homeMap: 'https://www.inhealth.iotena.com/api/home/home_map',/*地图酒店*/

    roomEnvStatus: 'https://www.inhealth.iotena.com/api/home/room_env_status2',/*新版首页数据*/
  },
  // uv灯
  uvLight: {
    save: 'https://www.inhealth.iotena.com/api/uvLight/save',/*创建/编辑设备*/
    details: 'https://www.inhealth.iotena.com/api/uvLight/details',/*设备详情*/
    getList: 'https://www.inhealth.iotena.com/api/uvLight/getList',/*列表*/
    del: 'https://www.inhealth.iotena.com/api/uvLight/del',/*删除设备*/
    setLight: 'https://www.inhealth.iotena.com/api/uvLight/setLight',/*设备设置开关*/
    setTotalLight: 'https://www.inhealth.iotena.com/api/uvLight/setTotalLight',/*一键开启/关闭*/
  },
  /*智慧校园*/
  smartCampus: {
    save_light: 'https://www.inhealth.iotena.com/api/school/save_light',/*添加编辑设备*/
    dev_list: 'https://www.inhealth.iotena.com/api/school/dev_list',/*获取房间设备*/
    charge_location: 'https://www.inhealth.iotena.com/api/school/charge_location',/*修改位置*/
    set_curtain: 'https://www.inhealth.iotena.com/api/school/set_curtain',/*开关窗帘*/
    light_list: 'https://www.inhealth.iotena.com/api/school/light_list',/*获取信息列表*/
    // set_color_light:'https://www.inhealth.iotena.com/api/school/set_color_light',/*设置色温亮度*/
    del_light: 'https://www.inhealth.iotena.com/api/school/del_light',/*删除设备*/

    get_model: 'https://www.inhealth.iotena.com/api/school/get_model',/*获取情景模式设置*/
    set_model: 'https://www.inhealth.iotena.com/api/school/set_model',/*设置情景模式设置*/

    set_color: 'https://www.inhealth.iotena.com/api/school/set_color',/*设置色温*/
    set_light: 'https://www.inhealth.iotena.com/api/school/set_light',/*设置亮度*/

    get_panel_mode: 'https://www.inhealth.iotena.com/api/school/get_panel_mode',/*获取面板模式设置*/
    set_panel_mode: 'https://www.inhealth.iotena.com/api/school/set_panel_mode',/*设置面板模式*/

    get_curtain_mode: 'https://www.inhealth.iotena.com/api/school/get_curtain_mode',/*获取窗帘模式设置*/
    set_curtain_mode: 'https://www.inhealth.iotena.com/api/school/set_curtain_mode',/*设置窗帘模式*/

    get_model_nav: 'https://www.inhealth.iotena.com/api/school/get_model_nav',/*获取模式下拉*/

    charge_dev_type: 'https://www.inhealth.iotena.com/api/network/charge_dev_type',/*修改设备类型*/

    set_group: 'https://www.inhealth.iotena.com/api/school/set_group',/*设置分组*/
    set_blink: 'https://www.inhealth.iotena.com/api/school/set_blink',/*设备闪一闪*/
    get_scene: 'https://www.inhealth.iotena.com/api/school/get_scene',/*获取情景模式信息*/
    set_scene: 'https://www.inhealth.iotena.com/api/school/set_scene',/*设置情景模式*/
    get_group_list: 'https://www.inhealth.iotena.com/api/school/get_group_list',/*分组列表*/
    get_group_scene: 'https://www.inhealth.iotena.com/api/school/get_group_scene',/*分组列表*/
  },
  room: {
    buildNav: 'https://www.inhealth.iotena.com/api/room/build_nav',/*楼房下拉列表*/
    floorNav: 'https://www.inhealth.iotena.com/api/area/floor_nav',/*楼层下拉列表*/
    roomList: 'https://www.inhealth.iotena.com/api/room/room_list',/*房间列表*/
    roomNav: 'https://www.inhealth.iotena.com/api/room/room_nav',/*房间下拉列表*/
    roomCmd: 'https://www.inhealth.iotena.com/api/room/room_cmd',/*房间指令*/
    floorBuildImage: 'https://www.inhealth.iotena.com/api/area/floor_build_image',/**/

    getPlaneLayoutInfo: 'https://www.inhealth.iotena.com/api/area/get_plane_layout_info',/*获取平面布局信息*/
    setDevLocation: 'https://www.inhealth.iotena.com/api/area/set_dev_location',/*修改设备位置信息*/
    setPlaneLayoutInfo: 'https://www.inhealth.iotena.com/api/area/set_plane_layout_info',/*批量添加设备*/
    getPlaneLayoutDevInfo: 'https://www.inhealth.iotena.com/api/area/get_plane_layout_dev_info',/*平面布局设备信息概览*/
    updateDevInfo: 'https://www.inhealth.iotena.com/api/area/update_dev_info',/*编辑设备信息*/
    setLayoutImage: 'https://www.inhealth.iotena.com/api/area/set_layout_image',/*楼层绑定平面图*/
    getLayoutImage: 'https://www.inhealth.iotena.com/api/area/get_layout_image',/*获取楼层平面图*/
    getInputExcel: 'https://www.inhealth.iotena.com/api/area/get_input_excel',/*获取批量导入excel模版下载地址*/
    batchInput: 'https://www.inhealth.iotena.com/api/area/batch_input',/*批量导入绑定设备地址*/
    copyDevList: 'https://www.inhealth.iotena.com/api/area/copy_dev_list',/*拷贝设备*/
    delDev: 'https://www.inhealth.iotena.com/api/area/del_dev',
    userAuthentication: 'https://www.inhealth.iotena.com/api/area/User_authentication',/*验证当前账户*/

    set_room_plan: 'https://www.inhealth.iotena.com/api/lamp/set_room_plan',/*房间绑定配方*/
    guangbo_dim: 'https://www.inhealth.iotena.com/api/lamp/guangbo_dim',/*HCL设备广播调光调色温*/
  },
  roomLight: {
    lightList: 'https://www.inhealth.iotena.com/api/lamp/light_list',/*设备列表*/
    lightInfo: 'https://www.inhealth.iotena.com/api/lamp/light_info',/*设备详情*/
    lampCmd: 'https://www.inhealth.iotena.com/api/lamp/lamp_cmd',/*设备调光调色温*/
    saveLight: 'https://www.inhealth.iotena.com/api/lamp/save_light',/*添加编辑设备*/
    delLight: 'https://www.inhealth.iotena.com/api/lamp/del_light',/*删除设备*/
    lampLight: 'https://www.inhealth.iotena.com/api/lamp/lamp_light',/*单独调光*/
    lampColor: 'https://www.inhealth.iotena.com/api/lamp/lamp_color',/*单独调色温*/
    // lampColorRgb:'https://www.inhealth.iotena.com/api/lamp/lamp_color_rgb',/*单独设置颜色*/
    lampReport: 'https://www.inhealth.iotena.com/api/lamp/lamp_report',/*设备日志信息*/
    lampTurn: 'https://www.inhealth.iotena.com/api/lamp/lamp_turn',/*开关灯*/

    sensorList: 'https://www.inhealth.iotena.com/api/sensor/sensor_list',/*设备列表*/
    saveSensor: 'https://www.inhealth.iotena.com/api/sensor/save_sensor',/*添加编辑设备*/
    sensorInfo: 'https://www.inhealth.iotena.com/api/sensor/sensor_info',/*设备详情*/
    delSensor: 'https://www.inhealth.iotena.com/api/sensor/del_sensor',/*删除设备*/
    sensorHistory: 'https://www.inhealth.iotena.com/api/sensor/sensor_history',/*设备历史记录*/
    updateSensorInfo: 'https://www.inhealth.iotena.com/api/sensor/update_sensor_info',/*更新设备数据*/
    dev_register: 'https://www.inhealth.iotena.com/api/sensor/dev_register',/*手动注册巡检指令*/
    set_status: 'https://www.inhealth.iotena.com/api/sensor/set_status',/*开关探头3秒巡检指令*/

    purifierList: 'https://www.inhealth.iotena.com/api/purifier/purifier_list',/*设备列表*/
    savePurifier: 'https://www.inhealth.iotena.com/api/purifier/save_purifier',/*添加编辑设备*/
    purifierInfo: 'https://www.inhealth.iotena.com/api/purifier/purifier_info',/*设备详情*/
    delPurifier: 'https://www.inhealth.iotena.com/api/purifier/del_purifier',/*删除设备*/
    trunOffDevice: 'https://www.inhealth.iotena.com/api/purifier/trun_off_device',/*开关空气净化器*/
    // purifierReport:'https://www.inhealth.iotena.com/api/purifier/purifier_report',/*设备日志信息*/
    clean_time: 'https://www.inhealth.iotena.com/api/purifier/clean_time',/*清空滤网工作时间*/

    lampLightAsy: 'https://www.inhealth.iotena.com/api/lamp/lamp_light_asy',/*批量调光*/
    lampColorAsy: 'https://www.inhealth.iotena.com/api/lamp/lamp_color_asy',/*批量调色温*/
    lampColorRgb: 'https://www.inhealth.iotena.com/api/lamp/lamp_color_rgb',/*批量调颜色*/

    lightStyle: 'https://www.inhealth.iotena.com/api/light/style',/*IH-DM03、IH-DE03三种调节机制*/

    lightLightStd: 'https://www.inhealth.iotena.com/api/light/Light_light_std',/*单通道调光*/

    lampLogList: 'https://www.inhealth.iotena.com/api/lamp/log_list',/*设备日志信息列表*/
    purifierReport: 'https://www.inhealth.iotena.com/api/purifier/purifier_report',/*设备日志信息列表*/
    purifierLogList: 'https://www.inhealth.iotena.com/api/purifier/log_list',/*设备日志信息列表*/

    set_mode_and_time: 'https://www.inhealth.iotena.com/api/purifier/set_mode_and_time',/*设置air模式跟工作时间*/
    get_mode_and_time: 'https://www.inhealth.iotena.com/api/purifier/get_mode_and_time',/*获取air模式跟工作时间*/

    sensorLogList: 'https://www.inhealth.iotena.com/api/sensor/log_list',/*设备日志信息列表*/
    reData: 'https://www.inhealth.iotena.com/api/lamp/re_data',/*刷新数据*/

    getHotelEditforecast: 'https://www.inhealth.iotena.com/api/light/get_hotel_editforecast',/*修改设备日出时间日落时间*/
    getHotelPattern: 'https://www.inhealth.iotena.com/api/light/get_hotel_pattern',/*模式调光*/
    getHotelForecast: 'https://www.inhealth.iotena.com/api/light/get_hotel_forecast',/*获取酒店默认日出日落时间*/

    excelList: 'https://www.inhealth.iotena.com/api/light/excelList',/*显示当前用户上传的文件列表*/
    CirExcel: 'https://www.inhealth.iotena.com/api/light/CirExcel',/*上传计划*/
    del: 'https://www.inhealth.iotena.com/api/light/del',/*删除计划*/
    load: 'https://www.inhealth.iotena.com/api/light/load',/*下载计划*/
    plan: 'https://www.inhealth.iotena.com/api/light/plan',/*计划下拉列表*/
    addplan: 'https://www.inhealth.iotena.com/api/light/addplan',/*绑定计划*/
    download: 'https://www.inhealth.iotena.com/api/light/download',/*下载模板*/

    newTime: 'https://www.inhealth.iotena.com/api/light/new_time',/*初始化时间*/
    lightTest: 'https://www.inhealth.iotena.com/api/light/test',/*run两分钟测试*/
    sleepOpen: 'https://www.inhealth.iotena.com/api/light/sleepOpen',/*起床睡觉模式*/
    lightLampLight: 'https://www.inhealth.iotena.com/api/light/lamp_light',/*调光*/
    lightLampColor: 'https://www.inhealth.iotena.com/api/light/lamp_color',/*调色温*/


    r_w_light: 'https://www.inhealth.iotena.com/api/school/r_w_light',/*灯设备读写照度值*/
  },
  gateway: {
    getlist: 'https://www.inhealth.iotena.com/api/network/getlist',/*网关列表*/
    addRoomNet: 'https://www.inhealth.iotena.com/api/network/addRoomNet',/*添加网关*/
    delRoomNet: 'https://www.inhealth.iotena.com/api/network/delRoomNet',/*删除网关*/
    getLamp: 'https://www.inhealth.iotena.com/api/network/getLamp',/*获取设备列表*/
    addNetLamp: 'https://www.inhealth.iotena.com/api/network/addNetLamp',/*设备绑定网关*/
    statusControl: 'https://www.inhealth.iotena.com/api/network/statusControl',/*灯闪*/
    inspecTimeNav: 'https://www.inhealth.iotena.com/api/network/inspec_time_nav',/*获取巡检时间下拉*/

    checkUpdate: 'https://www.inhealth.iotena.com/api/network/check_update',/*检查更新*/
    updateFire: 'https://www.inhealth.iotena.com/api/network/update_fire',/*固件升级*/

    getWifiName: 'https://www.inhealth.iotena.com/api/network/get_wifi_name',/*获取网关绑定的wifi名称*/
    setWifi: 'https://www.inhealth.iotena.com/api/network/set_wifi',/*设置wifi*/
    getWifiList: 'https://www.inhealth.iotena.com/api/network/get_wifi_list',/*获取wifi列表*/

  },
  service: {
    getList: 'https://www.inhealth.iotena.com/api/alarm/get_list',/*故障信息列表*/
    delAlarm: 'https://www.inhealth.iotena.com/api/alarm/del_alarm',/*删除故障*/
    alarmInfo: 'https://www.inhealth.iotena.com/api/alarm/alarm_info',/*故障详情*/
    repairGetList: 'https://www.inhealth.iotena.com/api/repair/get_list',/*维修人员信息列表*/
    saveRepair: 'https://www.inhealth.iotena.com/api/repair/save_repair',/*添加编辑维修人员*/
    delRepair: 'https://www.inhealth.iotena.com/api/repair/del_repair',/*删除维修人员*/
    repairAuthList: 'https://www.inhealth.iotena.com/api/repair/repair_auth_list',/*获取维修人员酒店权限*/
    setRepairAuth: 'https://www.inhealth.iotena.com/api/repair/set_repair_auth',/*设置维修人员酒店权限*/
    repairStatis: 'https://www.inhealth.iotena.com/api/alarm/repair_statis',/*故障统计信息*/
    repairNav: 'https://www.inhealth.iotena.com/api/repair/repair_nav',/*维修人员下拉*/
    repairDispatch: 'https://www.inhealth.iotena.com/api/repair/repair_dispatch',/*维修调度*/
    repairDeal: 'https://www.inhealth.iotena.com/api/repair/repair_deal',/*维修调度*/

    hotelNav: 'https://www.inhealth.iotena.com/api/alarm/hotel_nav',/*酒店侧栏列表*/
    sendUserList: 'https://www.inhealth.iotena.com/api/alarm/send_user_list',/*告警推送人员列表*/
    addSendList: 'https://www.inhealth.iotena.com/api/alarm/add_send_list',/*添加告警推送人员下拉列表*/
    addSendUser: 'https://www.inhealth.iotena.com/api/alarm/add_send_user',/*添加告警推送人员*/
    delSendUser: 'https://www.inhealth.iotena.com/api/alarm/del_send_user',/*删除告警推送人员*/
    setSendUserStatus: 'https://www.inhealth.iotena.com/api/alarm/set_send_user_status',/*启动禁用告警推送人员*/
  },
  activityHistory: {
    logList: 'https://www.inhealth.iotena.com/api/operation/log_list',/*获取日志信息列表*/
    delLog: 'https://www.inhealth.iotena.com/api/operation/del_log',/*删除日志信息*/
  },
  alarmProfile: {
    getList: 'https://www.inhealth.iotena.com/api/alarmProfle/get_list',/*数据列表*/
    saveAlarmProfile: 'https://www.inhealth.iotena.com/api/alarmProfle/save_alarm_profle',/*添加编辑*/
    getInfo: 'https://www.inhealth.iotena.com/api/alarmProfle/get_info',/*详情*/
    delAlarmProfile: 'https://www.inhealth.iotena.com/api/alarmProfle/del_alarm_profle',/*删除*/
    setAlarmProfile: 'https://www.inhealth.iotena.com/api/alarmProfle/set_alarm_profle',/*设置*/
    getNav: 'https://www.inhealth.iotena.com/api/alarmProfle/get_nav',/*获取下拉列表*/
    setRoom: 'https://www.inhealth.iotena.com/api/alarmProfle/set_room',/*房间设置警报*/
  },
  userManagement: {
    userNav: 'https://www.inhealth.iotena.com/api/user/user_nav',/*用户下拉列表*/
    userList: 'https://www.inhealth.iotena.com/api/user/user_list',/*用户列表*/
    saveUser: 'https://www.inhealth.iotena.com/api/user/save_user',/*添加编辑用户*/
    userInfo: 'https://www.inhealth.iotena.com/api/user/user_info',/*获取用户详情*/
    delUser: 'https://www.inhealth.iotena.com/api/user/del_user',/*删除用户*/
    getUserPermission: 'https://www.inhealth.iotena.com/api/user/get_user_permission',/*获取用户权限列表*/
    setUserPermission: 'https://www.inhealth.iotena.com/api/user/set_user_permission',/*修改用户权限*/
    userManage: 'https://www.inhealth.iotena.com/api/user/user_manage',/*用户概览信息*/
    updateFile: 'https://www.inhealth.iotena.com/api/common/update_file',/*图片上传*/
    setUserStatus: 'https://www.inhealth.iotena.com/api/user/set_user_status',/*启用禁用用户状态*/
  },
  siteManagement: {
    getCountry: 'https://www.inhealth.iotena.com/api/common/get_country',/*添加酒店国家下拉*/
    getProvince: 'https://www.inhealth.iotena.com/api/common/get_province',/*添加酒店省份下拉*/
    getCity: 'https://www.inhealth.iotena.com/api/common/get_city',/*添加酒店城市下拉*/
    hotelNavList: 'https://www.inhealth.iotena.com/api/area/hotel_nav_list',/*酒店侧栏下拉*/
    saveHotel: 'https://www.inhealth.iotena.com/api/area/save_hotel',/*添加编辑酒店*/
    hotelInfo: 'https://www.inhealth.iotena.com/api/area/hotel_info',/*酒店详情*/
    delHotel: 'https://www.inhealth.iotena.com/api/area/del_hotel',/*删除酒店*/

    saveFloor: 'https://www.inhealth.iotena.com/api/area/save_floor',/*添加楼层*/
    delFloor: 'https://www.inhealth.iotena.com/api/area/del_floor',/*删除楼层*/
    updateFloor: 'https://www.inhealth.iotena.com/api/area/update_floor',

    saveBuild: 'https://www.inhealth.iotena.com/api/area/save_build',/*添加编辑楼房*/
    delBuild: 'https://www.inhealth.iotena.com/api/area/del_build',/*删除楼房*/
    buildInfo: 'https://www.inhealth.iotena.com/api/area/build_info',/*楼房详情*/

    roomList: 'https://www.inhealth.iotena.com/api/area/room_list',/*酒店管理房间列表*/
    saveRoom: 'https://www.inhealth.iotena.com/api/room/save_room',/*添加编辑房间*/
    roomInfo: 'https://www.inhealth.iotena.com/api/room/room_info',/*获取房间详细信息*/
    delRoom: 'https://www.inhealth.iotena.com/api/room/del_room',/*删除房间*/

    updateHotelLogo: 'https://www.inhealth.iotena.com/api/area/update_hotel_logo',/*修改酒店logo*/
  }
}
export default urls